import { useQuery } from '@tanstack/react-query';
import { capabilitiesApi } from '@/services/capabilitiesApi';
import { useAuthStore } from '@/stores/useAuthStore';

export const useCapabilities = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: ['capabilities', 'me'],
    queryFn: () => capabilitiesApi.getMine(),
    enabled: isAuthenticated,
    staleTime: 60_000,
  });
};
